var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green"},[_c('van-nav-bar',{attrs:{"title":"订单核销","fixed":"","z-index":100}}),_c('van-icon',{attrs:{"name":"checked"}}),_c('div',{staticClass:"text"},[_vm._v(" 核销成功 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }